<!-- 保单信息 -->
<template>
  <div>
    <a-form id="container" layout="horizontal" class="horizontal_item_" :form="form">
      <a-row>
        <div id="start" class="title_">
          <div class="cutleft_">投保地区</div>
          <div class="cutoff_"></div>
        </div>
        <a-col :span="10">
          <a-form-item :label-col="{ span: 6 }" label="投保地区">
            <a-select v-model="flightDepcode" 
            v-decorator="[
              'salPolicy.flightDepcode',
              {
                rules: [{ required: true, message: '请选择投保地区!' }],
              },
            ]" placeholder="请选择投保地区">
              <a-select-option v-for="item in addresOptions" :value="item.addres" :key="item.addres">{{item.addres}}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="10" :offset="2">
          <a-form-item :label-col="{ span: 6 }" label="保司">
            <a-select v-model='flightArrtimeplan' v-decorator="[
            'salPolicy.flightArrtimeplan',
            {
              rules: [{ required: true, message: '请选择保司!' }],
            },
          ]" placeholder="请选择保司" @change="(e)=>flightArrtimeplanChange(e)">
              <a-select-option v-for="item in bsOption" :value="item.bsName" :key="item.bsName">{{item.bsName}}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row>
        <div id="start" class="title_">
          <div class="cutleft_">基础信息</div>
          <div class="cutoff_"></div>
        </div>
        <a-col :span="10">
          <a-form-item :label-col="{ span: 6 }" label="分公司">
            <a-select v-decorator="[
            'salPolicy.flightDeptimeplan',
            {
              rules: [{ required: true, message: '请选择分公司!' }],
            },
          ]" placeholder="请选择分公司">
              <a-select-option v-for="item in fgsOption" :value="item.fgs" :key="item.fgs">{{item.fgs}}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="10" :offset="2">
          <a-form-item :label-col="{ span: 6 }" label="法务邮箱">
            <a-input v-decorator="['salPolicyHolder.invoiceno', { rules: [{ required: true, message: '请输入法务邮箱' },
            { pattern: $regTest.checkEmail, message: '联系人邮箱不正确' }] }]" placeholder="请输入法务邮箱" />
          </a-form-item>
        </a-col>
        <a-col :span="10">
          <a-form-item :label-col="{ span: 6 }" label="接收保单邮箱">
            <a-input v-decorator="['salPolicyHolder.email', { rules: [{ required: true, message: '请输入接收保单邮箱' },
            { pattern: $regTest.checkEmail, message: '联系人邮箱不正确' }] }]" placeholder="请输入接收保单邮箱" />
          </a-form-item>
        </a-col>
        <a-col :span="10" :offset="2">
          <a-form-item :label-col="{ span: 6 }" label="员工编号">
            <a-input v-decorator="['salPolicyHolder.useidnum', { rules: [{ required: true, message: '请输入员工编号' }] }]"
              placeholder="请输入员工编号" />
          </a-form-item>
        </a-col>
        <a-col :span="10">
          <a-form-item :label-col="{ span: 6 }" label="保险金额">
            <a-input type="number" @blur="(e)=>calPremiumEmployer(e.target.value)"
              v-decorator="['salPolicy.destination', { rules: [{ required: true, message: '请输入保险金额' }] }]"
              placeholder="请输入保险金额" />
          </a-form-item>
        </a-col>
        <a-col :span="10" :offset="2">
          <a-form-item class="m_span3" :label-col="{ span: 6 }" label="保险起期">
            <a-date-picker placeholder="保险起期" :disabledDate="StartdisabledDateRange" style="width: 100%" v-decorator="[
                'salPolicy.effectiveDate',
                {
                  rules: [{ required: true, message: '请选择保险起期!' }],
                },
              ]" />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row>
        <div id="start" class="title_">
          <div class="cutleft_">投保方案</div>
          <div class="cutoff_"></div>
        </div>
        <a-col :span="10">
          <a-form-item :label-col="{ span: 6 }" label="投保人">
            <a-select @change="viewInfo" v-decorator="[
                'salPolicyHolder.name',
                {
                  rules: [{ required: true, message: '请选择投保人!' }],
                },
              ]" placeholder="请选择投保人">
              <a-select-option v-for="item in policyNameList" :key="item.value" :value="item.value">{{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="10" :offset="2">
          <a-form-item :label-col="{ span: 6 }" label="投保人证件类型">
            <a-select v-decorator="[
                'salPolicyHolder.idType',
                {
                  rules: [{ required: true, message: '请选择投保人证件类型!' }],
                },
              ]" placeholder="请选择投保人证件类型">
              <a-select-option v-for="item in companyIdTypeOptions" :key="item.value" :value="item.value">
                {{ item.name }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="10">
          <a-form-item :label-col="{ span: 6 }" label="投保人证件号">
            <a-input v-decorator="['salPolicyHolder.idNumber', { rules: [{ required: true, message: '请输入投保人证件号！' }] }]"
              placeholder="请输入投保人证件号" />
          </a-form-item>
        </a-col>
        <a-col :span="10" :offset="2">
          <a-form-item :label-col="{ span: 6 }" label="联系电话">
            <a-input v-decorator="['salPolicyHolder.telephone', { rules: [{ required: true, message: '请输入联系电话！' }] }]"
              placeholder="请输入联系电话" />
          </a-form-item>
        </a-col>
        <a-col :span="10">
          <a-form-item :label-col="{ span: 6 }" label="投保人地址">
            <a-input v-decorator="['salPolicyHolder.address', { rules: [{ required: true, message: '请输入投保人地址！' }] }]"
              placeholder="请输入投保人地址！" />
          </a-form-item>
        </a-col>
        <a-col :span="10" :offset="2">
          <a-form-item :label-col="{ span: 6 }" label="投保人类型">
            <a-select v-decorator="[
                'salPolicyHolder.type',
                {
                  rules: [{ required: true, message: '请选择投保人类型!' }],
                },
              ]" placeholder="请选择投保人类型">
              <a-select-option v-for="item in industryType" :key="item.value" :value="item.value">{{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="10">
          <a-form-item :label-col="{ span: 6 }" label="邮编">
            <a-input v-decorator="['salPolicyHolder.postCode', { rules: [{ required: true, message: '请输入邮编！' }] }]"
              placeholder="请输入邮编" />
          </a-form-item>
        </a-col>
      </a-row>
      <salInsured ref="salInsured" :planType='planType' :name='name' @checked="salInsuredCheckedFields"></salInsured>
      <a-row>
        <div class="title_">
          <div class="cutleft_">总保费</div>
          <div class="cutoff_"></div>
        </div>
        <a-form-item :label-col="{ span:2 }" label="汇款金额">
          <a-input v-decorator="['salPolicy.tickets',{
                  rules: [{ required: true, message: '请输入汇款金额!' }],
                }]" style="width: 200px" placeholder="请输入汇款金额" />
        </a-form-item>
        <a-form-item label="保费" :label-col="{ span:2}">
          <a-input v-model="totalPremium" disabled style="width: 200px" addonAfter="元" />
        </a-form-item>
      </a-row>
    </a-form>
    <a-row class="order">
      <a-col :span="24">
        <a-form-item :wrapper-col="{ span: 12, offset: 10 }">
          <a-button class="btn_color" type="primary" :loading="submitLoad" @click="save">保存订单</a-button>
        </a-form-item>
      </a-col>
    </a-row>
  </div>
</template>

<script>
  //这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
  //例如：import 《组件名称》 from '《组件路径》';
  // import { REQUIRERULE } from "./formRule";
  let DATA = require('../data').default;
  let options = require('../data/options').default;
  import moment from "moment";
  import salInsured from './salInsured';
  export default {
    components: { salInsured },
    data() {
      //这里存放数据
      return {
        submitLoad: false, //按钮状态
        creator: "",
        productCode: "",
        planType: 'zl',
        checkedFieldFlag: true, //子组件字段校验状态
        form: this.$form.createForm(this, { name: 'coordinated' }),
        applicantInfo: {},
        totalPremium: 0, //总保费
        addresOptions: options.addresOptions,
        //投保人证件类型
        companyIdTypeOptions: DATA.companyIdTypeOptions,
        //投保人名称
        policyNameList: DATA.policyNameList,
        //投保人类型
        name: '',
        industryType: DATA.industryType,
        pieces: '',//开户行
        seatNumber: '',//账号
        flightArrcode: '',//邮箱
        flightDepcode: '', //投保地区
        flightArrtimeplan: '', 
      };
    },
    //监听属性 类似于data概念
    computed: {
      bsOption() {
        //保司 options
        let addresOptions = this.$lodash.cloneDeep(options.addresOptions);
        let arr = addresOptions.filter(item => item.addres == this.flightDepcode);
        this.flightArrtimeplan = arr[0] && arr[0].bsName
        this.form.setFieldsValue({
          salPolicy:{
            flightArrtimeplan:this.flightArrtimeplan
          }
        })
        this.pieces = arr[0] && arr[0].pieces
        this.seatNumber = arr[0] && arr[0].seatNumber
        this.flightArrcode = arr[0] && arr[0].flightArrcode
        return arr;
      },
      fgsOption() {
        //分公司 options
        let addresOptions = this.$lodash.cloneDeep(options.addresOptions);
        let arr = addresOptions.filter(item => item.addres == this.flightDepcode);
        return arr[0] && arr[0].children;
      }
    },
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
      flightArrtimeplanChange(e) {
        if (e.indexOf('紫金') > -1) {
          this.planType = 'zj'
        } else {
          this.planType = 'zl'
        }
      },
      StartdisabledDateRange(current) {
        //时间选择器限制时间
        let hour = moment().get('hour');
        let minute = moment().get('minute');
        if (hour >= 16 && minute >= 30) {//下午四点半之后 t+2
          return current && current < moment().add(1, "days")
        } else {
          return current && current < moment()
        }
      },
      viewInfo(value) {
        //自动带出投保人信息
        let item = this.policyNameList.filter(item => item.name == value)[0];
        this.name = value
        this.form.setFieldsValue({
          salPolicyHolder: {
            ...item
          }
        });
      },
      calPremiumEmployer(value) {
        //算费接口
        let parms = {
          salPolicy: {
            productCode: this.productCode, //产品code
            destination: value, //保额
            planCode: 'ZLZSSZXZJ' //计划code
          }
        };
        this.$api.calPremiumEmployer(parms).then(res => {
          this.totalPremium = res.data.content.totalPremium;
        });
      },
      save() {
        //保存接口
        this.$refs.salInsured.checkFields();
        this.form.validateFields((err, values) => {
          if (!err && this.checkedFieldFlag) {
            this.submitLoad = true
            let salData = this.$refs.salInsured.save();
            let parms = {
              salPolicy: {
                planCode: this.planType == 'zl' ? "ZLZSSZXLB" : "ZLZSSZXZJ",
                productCode: this.productCode,
                creator: this.creator,
                ...salData.salPolicy,
                ...values.salPolicy,
                totalPremium: this.totalPremium,
                pieces: this.pieces,
                flightArrcode: this.flightArrcode,
                seatNumber: this.seatNumber,
                payMethod: "0",// 线下支付：0
                effectiveDate: moment(values.effectiveDate).format("YYYY-MM-DD"),
                expireDate: this.planType == 'zl' ? moment(values.effectiveDate).add(2, 'years').format("YYYY-MM-DD") : '2099-01-01'
              },
              salPolicyHolder: {
                ...salData.salPolicyHolder,
                ...values.salPolicyHolder,
              },
              salInsuredList: [
                {
                  ...values.salPolicyHolder,
                  relationship: "1"
                }
              ]
            }
            this.$api
              .employerPolicy(parms)
              .then((r) => {
                if (r.data.returnCode == "00") {
                  if (r.data.content) {
                    this.goSuccess(r.data.content);
                  }
                }
              })
              .catch(() => {
                this.submitLoad = false;
                this.$message.warning("订单保存失败！");
              });
          }
        });
      },
      goSuccess(policyId) {
        this.sendEmail(policyId);
        this.$router.push({
          name: "insuresuccess",
          query: {
            policyId: policyId,
          },
        });
      },
      sendEmail(policyId) {
        let parms = {
          policyId: policyId,
        }
        this.$api
              .liBaoSendEmail(parms)
              .then()
      },
      salInsuredCheckedFields(value) {
        //校验必填字段状态
        if (!value) {
          this.checkedFieldFlag = false;
          this.submitLoad = false;
        }
      },
      rangePickerEnd() {

      }
    },
    mounted() { },
    created() {
      const { u, p } = this.$route.query;
      this.creator = u; //用户id
      this.productCode = p; //产品code
    },
  };
</script>
<style scoped>
  .avatar-uploader>>>.ant-upload {
    width: 128px;
    height: 128px;
  }

  .textarea_label>>>.ant-col-2 {
    width: 125px !important;
  }

  .avatar-uploader>>>.ant-upload img {
    width: 100%;
    height: 100%;
  }

  .ant-upload-select-picture-card i {
    font-size: 32px;
    color: #999;
  }

  .ant-upload-select-picture-card .ant-upload-text {
    margin-top: 8px;
    color: #666;
  }

  .btn_color {
    margin: 0 20px;
  }
</style>